import React from "react";
import InquiryForm from "../components/InquiryForm";
import { SCHOOL_INQUIRY } from "../data/inquiryForms";
import "./Offerings.css";

/** Creative Wellness Program (school-based) + School Inquiry Form. */
export default function Schools() {
  return (
    <section className="section white offerings-page">
      <div className="container">
        <h1>Creative Wellness Program: School-Based Art Therapy</h1>
        <div className="offering-intro">
          <p>
            The Creative Wellness Program is an ongoing, structured art therapy program designed to be embedded into your school’s calendar, semester by semester, week by week. It’s not a one-time workshop. It’s a consistent therapeutic presence in your students’ lives.
          </p>
          <p>
            The program is open to students of all backgrounds and abilities. It has been designed with particular attention to students who benefit from a creative, non-verbal approach to emotional support, including but not limited to students diagnosed with Autism Spectrum Disorder, Attention Deficit Hyperactivity Disorder, anxiety, or other conditions that affect emotional regulation and communication. All students are welcome, and all approaches are person-first.
          </p>
          <p>
            Each program is customized to your school’s student population, schedule, and goals. Sessions are facilitated by Jasmine G. Smith, MS, ATR-P, LPC, NCC, under clinical supervision, and include a structured curriculum, parent and aide guides, and ongoing communication with your school team.
          </p>
          <p>
            If you’re interested in bringing the Creative Wellness Program to your school, I’d love to connect and learn more about your community.
          </p>
        </div>
        <div className="inquiry-wrap">
          <InquiryForm form={SCHOOL_INQUIRY} />
        </div>
      </div>
    </section>
  );
}
